import React from 'react'

import { Button, Form, Grid, Header, Image, Modal, InputOnChangeData } from 'semantic-ui-react'

import CustomLabel from '../../components/common/custom-label/CustomLabel'
import ProjectWorkflowSelector from '../../components/project/ProjectWorkflowSelector'
import { ProjectType } from '../../config/projectTypes'

import imageOnboardingGetStarted from '../../_images/onboarding-get-started.png'

const ProjectNameModal = (props: IProjectNameModalProps) => {
  // Props
  const {
    loading,
    projectName,
    projectType,
    handleChangeProjectName,
    handleChangeProjectType,
    stepBack,
    stepForward,
    handleEndOnboarding,
  } = props

  return (
    <Modal open style={{ width: '100%', height: '100%', marginTop: '-14px' }}>
      <Modal.Content style={{ padding: 0 }}>
        <Grid style={{ height: '100vh', minHeight: '700px', margin: 0 }}>
          <Grid.Column
            only="computer"
            width={7}
            style={{ backgroundImage: 'linear-gradient(to bottom, #f1eff6, #f2f0f6)' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Header as="h1">Last steps - you're nearly all set up</Header>
              <Image src={imageOnboardingGetStarted} width={350} alt="vloggi" />
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} computer={9}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button disabled={loading} onClick={handleEndOnboarding}>
                  Skip
                </Button>
              </div>
              <div style={{ flex: 1, overflowY: 'auto', padding: '20px 100px 32px' }}>
                <Header as="h2">What do you want to collect?</Header>
                <p>Choose the submission workflow first. We’ll suggest a project name that you can edit.</p>
                <Form style={{ margin: '20px 0 10px 0' }}>
                  <ProjectWorkflowSelector value={projectType} onChange={handleChangeProjectType} />
                  <Form.Field>
                    <CustomLabel>
                      <CustomLabel.Text text="Suggested project name — you can edit this" />
                      <CustomLabel.WordCount word={projectName} limit={75}></CustomLabel.WordCount>
                    </CustomLabel>
                    <Form.Input
                      type="text"
                      name="teamName"
                      maxLength={75}
                      value={projectName}
                      onChange={handleChangeProjectName}
                    />
                  </Form.Field>
                </Form>
              </div>
              <div
                style={{
                  alignItems: 'center',
                  background: '#fff',
                  borderTop: '1px solid #e5e5e5',
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '12px 20px 28px',
                }}
              >
                <Button disabled={loading} onClick={stepBack}>
                  Back
                </Button>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <span>4 / 6</span>
                  <Button
                    primary
                    disabled={projectName.trim() === '' || loading}
                    loading={loading}
                    onClick={stepForward}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid>
      </Modal.Content>
    </Modal>
  )
}

interface IProjectNameModalProps {
  loading: boolean
  projectName: string
  projectType: ProjectType
  handleChangeProjectName: (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => void
  handleChangeProjectType: (projectType: ProjectType) => void
  stepBack: () => void
  stepForward: () => void
  handleEndOnboarding: () => void
}

export default ProjectNameModal
